module.exports = __webpack_public_path__ + "static/media/hey_mirror.f9e7e4cb.png";